import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import textUtil from '../../util/text';
import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';
import { formatWorkDuration } from '../../util/dates';

export class DetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    if (props.test) {
      this.state = {
        show: true,
        data: props.data
      };
    } else {
      this.state = {
        show: false,
        data: {}
      };
    }

    this.handleClose = this.handleClose.bind(this);
  }

  static defaultProps = {
    dateLabel: 'End date',
    valueLabel: 'Cycle time'
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data
      });
    }
  }

  handleClose() {
    this.setState({
      show: false,
      data: {}
    });

    trackChartPointDetailsView(this.props.chart, false);
  }

  renderDetail(d, y, bl, blockedTime, label, blockers) {
    const ct = formatWorkDuration(d.cycleTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const blockedList = _.find(bl, { listId: d.listId });
    const showBlockerInfo = blockers !== false && blockedTime === 'all';

    return (
      <p key={y}>
        {label}{' '}{d.list}: {ct}{' '}
        {showBlockerInfo && !!blockedList && (
          <span>
            {' '}
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}{' '}
          </span>
        )}{' '}
      </p>
    );
  }

  render() {
    const { show, data } = this.state;
    const { date, value, points } = data;
    const { blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        {!show || !points ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <div className='box_white_title mb-4'>
              <h3> {this.props.dateLabel}: {date}</h3>

              <div className='right-actions'>
                <Button className="btn-action" onClick={this.handleClose}>&times; </Button>
              </div>
            </div>

            <p>{this.props.valueLabel}: {value}</p>
            
            {!!data.value2 && (
              <p>
                {this.props.value2Label}: {data.value2}
              </p>
            )}

            <Accordion>
              {points.map((point, i) => {
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0} className={showBlockerInfo && !!point.card.blockedTime && 'accordion-item-blocked-card'}>
                    <Accordion.Header>
                      <span className={`label_dot ${isWhite(point.color) ? 'label_dot--white' : ''}`}  style={{ background: point.color }}></span>
                      {point.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!point.card.secondaryName && <p>Summary: {point.card.secondaryName}</p>}
                      {!!point.card.coloredField && (
                        <p>
                          {textUtil.format(point.card.coloredField, null, false, false, 'capitalize')}:{' '}
                          {point.card.coloredValue}
                        </p>
                      )}
                      <p>
                        {label} Cycle time:{' '}
                        {formatWorkDuration(_.sumBy(point.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
                      </p>

                      {showBlockerInfo && blockedTime === 'all' && !!point.card.blockedTime && (
                        <p className='block-item'>
                          Blocked time:{' '}
                          {formatWorkDuration(point.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
                        </p>
                      )}
                      {point.details.map((d, y) => {
                        return this.renderDetail(d, y, point.card.blockedLists, blockedTime, label, blockers);
                      })}
                      {!!point.card.url && (
                        <p>
                          <a href={point.card.url} target="_blank" className='btn btn-sm btn-light-secondary'>
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(DetailsAccordion);
